import constants from "../../../../../appConstants";
import { mergeUserConfig } from '@dataGrid/gridUtilities';
import { PICKUP_STATUS } from "../constants";
import { hasStopDelayed } from "../utils";

const getDriverMapConfig = (userConfig) => {
  const defaultConfig = {
    title: constants.mapName.DispatchMap,
    toggles: {
      isMapLegendEnabled: false,
      isRouteAnimationEnabled: true,
      isShowAllDriversEnabled: true,
      isShowDriverLabelEnabled: true,
      isExpandDriverStopListEnabled: false
    },
  };
  return mergeUserConfig({
    defaultConfig,
    userConfig,
  });
};

const isDriverDelayed = (route) => {
  return route.stops.findIndex((stop) => hasStopDelayed(stop)) > -1;
};

const getStopMarkerColors = ({ theme, stop, routeColor }) => {
  const otherMarkerColors = {
    gradientPrimaryColor: theme.gradientPrimaryColor,
    gradientSecondaryColor: theme.gradientSecondaryColor
  }
  if (hasStopDelayed(stop)) {
    return {
      color: theme.delayedStopMarkerColor,
      borderColor: theme.delayedStopMarkerColor,
      markerTextColor: theme.routeMapColorPalette.MarkerTextColor,
      ...otherMarkerColors
    };
  }
  return {
    color: routeColor,
    borderColor: theme.routeMapColorPalette.MarkerBorderColor,
    markerTextColor: theme.routeMapColorPalette.MarkerTextColor,
    ...otherMarkerColors
  };
};

const isPickupOnMapActive = (selectedPickups, currentPickupId) => {
  return Boolean(selectedPickups.find((pickup) => pickup.pickupId === currentPickupId));
};

const getIconBGAndBorderColor = ({ theme, pickupStatus }) => {
  switch (pickupStatus) {
    case PICKUP_STATUS.missed:
    case PICKUP_STATUS.voided:
      return { iconBGColor: theme.missedVoidedPickupFillColor };
    case PICKUP_STATUS.newPickup:
      return { iconBGColor: theme.newPickupFillColor };
    case PICKUP_STATUS.completed:
    case PICKUP_STATUS.noFreight:
    case PICKUP_STATUS.unacknowledged:
    case PICKUP_STATUS.notCompleted:
      return { iconBGColor: theme.pickupStatusFillColors };
    case PICKUP_STATUS.toBeReviewed:
      return { iconBGColor: theme.iconColor};
    default:
      return {
        iconBGColor: theme.unassignPickupFillColor,
        iconBorderColor: theme.markerStokeColor
      };
  }
};

const getPickupStopData = (routesList, pickup) => {
  const pickupRoute = routesList.find(
    (route) => route.routeId === pickup.routeId
  );

  if (pickup?.driverId && pickupRoute) {
    const stopData =
      pickupRoute.stops.find(
       (stop) => pickup.pickupId.toLowerCase()?.includes(stop.pickupId?.toLowerCase())
      ) ?? null;
    return {
      stopColor: pickupRoute.color,
      stopData: {
        ...stopData,
        driverName: pickup.driverName,
        driverNumber: pickup.driverNumber,
        driverId: pickup.driverId,
      },
    };
  } else {
    return {
      stopColor: null,
      stopData: null,
    };
  }
};

const isPickupDriverExistInGrid = ({
  currentActiveRoutes,
  driverId,
  routeId,
}) => {
  return currentActiveRoutes?.find(
    (driver) => driver.driverId === driverId && driver.routeId === routeId
  );
};

const isPickupUnassigned = (selectedPickupsList, pickupId) => {
  return !selectedPickupsList?.find(
    (pickup) => pickup.pickupId?.toLowerCase() === pickupId?.toLowerCase()
  )?.driverId;
};

const checkPickupExists = ({
  filteredPickups,
  selectedPickupsList,
  pickupId,
}) => {
  const isPickupIdExistInMap = filteredPickups.find(
    (pickup) => pickup.pickupId === pickupId
  );
  return isPickupIdExistInMap && selectedPickupsList.length > 0;
};

const getUnassignMarkerInfo = ({  isActive, theme , pickupStatus }) => {
  const { iconBGColor = theme.white, iconBorderColor = theme.white } = getIconBGAndBorderColor({theme, pickupStatus });
  if(isActive){
    return {
      backgroundColor: theme.white,
      borderColor: iconBGColor
    }
  }
  return {
    backgroundColor: iconBGColor,
    borderColor: iconBorderColor,
  };
};

const getPickupsRouteData = (routesList, eventData) => {
  if (eventData.success) {
    return routesList.find((r) => r.routeId?.toUpperCase() === eventData.routeId?.toUpperCase());
  }
  return routesList.find(
    (r) => r.driverId.toUpperCase() === eventData.driverId.toUpperCase()
  );
};

const formatDriverLocation = (driverLocation={}) => {
  const { lat, lng } = driverLocation;
  if (lat && lng) {
    return { lat, lng };
  }
  return null;
};

export {
  getDriverMapConfig,
  isDriverDelayed,
  getStopMarkerColors,
  isPickupOnMapActive,
  getIconBGAndBorderColor,
  getPickupStopData,
  isPickupDriverExistInGrid,
  isPickupUnassigned,
  checkPickupExists,
  getUnassignMarkerInfo,
  getPickupsRouteData,
  formatDriverLocation,
};
